// extracted by mini-css-extract-plugin
export default {"twolines":"CustomAppCard_twolines__31ppw","treelines":"CustomAppCard_treelines__++aOE"};